import API from '../../path';
import { fetch } from '@umu/umu-fetch';

export const getNextElement = (elementId: number) => {
    return fetch
        .get(API.GET_NEXT_ELEMENT.url, {
            element_id: elementId,
        })
        .then((response: IResponse<IElementInfo>) => {
            return response.data;
        });
};
